module.exports = __webpack_public_path__ + "img/iconLiShiCaoZuoXiangQing.09deb2d4.svg";